import React from 'react';

export default function MandalaBackground() {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none flex items-center justify-center opacity-[0.03] z-[-1]">
            <svg
                width="800"
                height="800"
                viewBox="0 0 200 200"
                className="animate-[spin_120s_linear_infinite] text-amber-500 scale-150 md:scale-[2]"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Outer Petals */}
                <path d="M100 0 L115 40 L160 20 L135 60 L185 85 L140 100 L185 115 L135 140 L160 180 L115 160 L100 200 L85 160 L40 180 L65 140 L15 115 L60 100 L15 85 L65 60 L40 20 L85 40 Z" stroke="currentColor" strokeWidth="0.5" />
                {/* Inner Petals */}
                <path d="M100 25 L110 55 L145 40 L125 70 L160 90 L125 100 L160 110 L125 130 L145 160 L110 145 L100 175 L90 145 L55 160 L75 130 L40 110 L75 100 L40 90 L75 70 L55 40 L90 55 Z" stroke="currentColor" strokeWidth="0.5" />

                {/* Concentric Circles */}
                <circle cx="100" cy="100" r="45" stroke="currentColor" strokeWidth="0.5" strokeDasharray="2 2" />
                <circle cx="100" cy="100" r="35" stroke="currentColor" strokeWidth="0.5" />

                {/* Inner Star/Geometry */}
                <path d="M100 65 L120 120 L75 85 L125 85 L80 120 Z" stroke="currentColor" strokeWidth="0.5" />
                <circle cx="100" cy="100" r="10" stroke="currentColor" strokeWidth="1" />
                <circle cx="100" cy="100" r="3" fill="currentColor" />
            </svg>
        </div>
    );
}
